import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { authenticatedHeadersHash } from "views_shared/app/javascript/scripts/authentication";
import ImageCropped from "views_shared/app/javascript/components/ImageCropped";

function PromoExpertResult({ gid }) {
  const match = gid.match(/gid:\/\/qwoted\/([^/]+)\/(\d+)/);
  const expertId = match ? match[2] : null;
  const [expert, setExpert] = useState(null);

  useEffect(() => {
    const query = `${globalThis.Qwoted.SUPABASE_API_EXTERNAL_URL}/rest/v1/experts?id=eq.${expertId}`;
    fetch(query, {
      method: "GET",
      headers: new Headers(authenticatedHeadersHash()),
    })
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson[0]) {
          const e = responseJson[0];
          setExpert(e);
        }
      });
  }, [expertId]);

  if (!expert) {
    return null;
  }

  return (
    <div className="d-flex">
      <ImageCropped wrapperClasses="me-2" src={expert.profile_image_url} alt={expert.name} size={45} />
      <div className="d-flex flex-column lh-sm">
        <a href={`/experts/${expert.slug}`}>
          <div className="fs-3">{expert.name}</div>
        </a>
        <div className="text-secondary">{expert.featured_title_at_company}</div>
        {globalThis.Qwoted.V1_URL && expert.migrate_id && (
          <a href={`${globalThis.Qwoted.V1_URL}/sources/${expert.migrate_id}?version=v1`}>V1 Link</a>
        )}
      </div>
    </div>
  );
}

PromoExpertResult.propTypes = {
  gid: PropTypes.string.isRequired,
};
export default PromoExpertResult;
